import { createComponent } from '@carvana/merch-components';
import { Section } from '@/ev-tax-credit/EvTaxCredit.styles';

const VehicleTile = `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/ev_tax_credit_vehicle_tile.png`;

export const HeroSection = createComponent(Section, {
  className:
    'mx-2xl flex flex-col items-center pt-6xl text-text-strong sm:mx-3xl sm:pt-4xl md:mx-[84px]'
});

export const GreenContainer = createComponent('div', {
  className:
    'grid auto-cols-fr rounded-2xl bg-[#a9e34b] px-2xl pb-9xl pt-6xl sm:px-4xl md:grid-flow-col md:gap-4xl md:px-[108px] md:py-8xl'
});

export const TopLeftContainer = createComponent('div', {
  className: 'flex flex-col gap-2xl'
});

export const BottomContainer = createComponent('div', {
  className: '-mt-80 ml-16 w-fit sm:ml-32 md:hidden' // Margin top pulls the image up, margin left centers the image
});

export const RightContainer = createComponent('div', {
  className: 'hidden flex-col justify-center md:flex'
});

export const VehicleTileImage = createComponent('img', {
  src: VehicleTile,
  alt: 'A vehicle advertising $4,000 tax credit',
  className: 'w-[243px] sm:w-[423px]'
});
